/* Báo giá tham khảo + yêu cầu cọc của khách tiềm năng — logic thuần, lưu trên máy chờ nối API */
import dayjs from 'dayjs';
import { NGUONG } from '../components/Data';
import type { DichVu } from './logic';

/** Trần giảm: mỗi dịch vụ / combo (CS giá 7.2, R31) */
export const TRAN_GIAM = 30;
export const TRAN_COMBO = 40;
/** Giảm vượt ngưỡng Tư vấn Online thì phải xin Trưởng phòng duyệt (CS giá 7.3) */
export const NGUONG_GIAM = NGUONG;

/**
 * Thẻ liệu trình báo cùng dịch vụ: gói theo buổi (dịch vụ + số buổi, có buổi tặng) hoặc thẻ trả trước (mệnh giá).
 * Bán theo giá gói — không áp % giảm của báo giá; POS phát hành thẻ khi thu tiền. Dùng chung với phiếu báo giá chính thức (App Tư vấn).
 */
export interface QuoteCard { code: string; kind: 'session' | 'value'; validityMonths: number; faceValue?: number; items: { name: string; sessions: number; bonus?: boolean }[]; /** Mã gói trên API thẻ liệu trình */ apiId?: number }
/** id = dịch vụ trong danh mục (/api/v1/be/services) — cùng giá màn Tạo lịch hẹn, POS; card = dòng là thẻ liệu trình (không có id dịch vụ) */
export interface QuoteSvc { id?: number; name: string; price: number | null; card?: QuoteCard }

/** Từ khoá gợi ý dịch vụ trong danh mục theo nhóm khách quan tâm */
export const DV_SEARCH: Record<DichVu, string> = { 'Cấy tóc': 'tóc', 'Căng chỉ': 'chỉ', 'Giảm cân': 'giảm', 'Điều trị da': 'da', 'Phun xăm': 'phun' };

/** Giá minh hoạ cũ — chỉ còn cho dữ liệu mẫu và test; báo giá thật lấy từ danh mục dịch vụ */
export const QUOTE_SVC: Record<DichVu, QuoteSvc[]> = {
  'Cấy tóc': [
    { name: 'Giải pháp Newhair · cấy tóc', price: 10_000_000 },
    { name: 'Giải pháp Newhair · Regen (phục hồi, không cấy)', price: 9_000_000 },
    { name: 'AI Hair Analysis (khám trước)', price: 1_000_000 },
  ],
  'Căng chỉ': [
    { name: 'Căng chỉ collagen toàn mặt', price: 15_000_000 },
    { name: 'Căng chỉ V-line', price: 8_000_000 },
    { name: 'Căng chỉ cổ', price: 6_000_000 },
    { name: 'Phác đồ K·Lift', price: 8_000_000 },
  ],
  'Giảm cân': [
    { name: 'Giảm mỡ vùng bụng (liệu trình 5 buổi)', price: 6_000_000 },
    { name: 'Liệu trình giảm cân 10 buổi', price: 12_000_000 },
    { name: 'Khám và đo InBody', price: 300_000 },
  ],
  'Điều trị da': [
    { name: 'Phác đồ K·Reskin', price: 6_000_000 },
    { name: 'Phác đồ K·Renewal', price: 5_000_000 },
    { name: 'Điều trị mụn chuẩn y khoa', price: 3_000_000 },
    { name: 'Điều trị nám · tàn nhang', price: 4_000_000 },
  ],
  'Phun xăm': [
    { name: 'Phun mày', price: 3_000_000 },
    { name: 'Phun môi', price: 3_500_000 },
    { name: 'Kẻ mí', price: 2_000_000 },
    { name: 'Xoá xăm cũ', price: 1_500_000 },
  ],
};

/** Chương trình ưu đãi đang chạy (tặng kèm) — minh hoạ */
export const PROMOS = ['Tặng 1 buổi chăm sóc sau làm', 'Miễn phí tái khám 3 tháng', 'Tặng gói khám AI Hair Analysis'];

export const SEND_CH = ['Zalo', 'Messenger', 'SMS', 'WhatsApp', 'Email'] as const;
export type SendCh = typeof SEND_CH[number];
export const DEP_PURPOSE = ['Giữ lịch', 'Giữ ưu đãi', 'Giữ bác sĩ'] as const;
export type DepPurpose = typeof DEP_PURPOSE[number];

export type QuoteSt = 'draft' | 'pending' | 'approved' | 'scheduled' | 'sent' | 'replied' | 'replaced' | 'cancelled';
export const QUOTE_ST: Record<QuoteSt, { label: string; color: string }> = {
  draft: { label: 'Nháp', color: 'default' },
  pending: { label: 'Chờ duyệt', color: 'orange' },
  approved: { label: 'Đã duyệt · chưa gửi', color: 'cyan' },
  scheduled: { label: 'Hẹn gửi', color: 'purple' },
  sent: { label: 'Đã gửi', color: 'blue' },
  replied: { label: 'Khách phản hồi', color: 'green' },
  replaced: { label: 'Đã thay thế', color: 'default' },
  cancelled: { label: 'Đã huỷ', color: 'default' },
};

/**
 * Vòng đời cọc: Chờ chuyển khoản → (khách gửi biên lai) Chờ đối soát → (Kế toán khớp sao kê) Đã nhận cọc
 * → lệnh Đẩy qua POS (tạo đơn hàng cọc) · hoặc Đã hoàn cọc / Khách bỏ cọc. Telesales không có nút đã cọc (R32).
 * "Đã trừ cọc" do POS báo về khi thanh toán (chưa làm ở đây).
 */
export type DepSt = 'waiting' | 'checking' | 'received' | 'used' | 'refunded' | 'forfeited' | 'cancelled' | 'refund_pending';
export const DEP_ST: Record<DepSt, { label: string; color: string }> = {
  waiting: { label: 'Chờ chuyển khoản', color: 'gold' },
  checking: { label: 'Chờ đối soát', color: 'orange' },
  received: { label: 'Đã nhận cọc', color: 'green' },
  used: { label: 'Đã trừ cọc', color: 'blue' },
  refunded: { label: 'Đã hoàn cọc', color: 'default' },
  forfeited: { label: 'Khách bỏ cọc', color: 'red' },
  /** Server: báo giá bị thay thế hoặc huỷ khi khách chưa chuyển tiền */
  cancelled: { label: 'Đã huỷ', color: 'default' },
  /** Server: huỷ báo giá đã nhận cọc; chưa có bước đã hoàn tiền (chờ PA, P2) */
  refund_pending: { label: 'Chờ hoàn cọc', color: 'volcano' },
};

/** Đơn hàng cọc tạo khi đẩy qua POS — khách đến thì POS trừ cọc, thu phần còn lại */
export interface DepositOrder {
  code: string;
  at: number;
  by: string;
  /** Dịch vụ theo báo giá */
  items: string[];
  /** Tổng đơn theo giá báo (sau giảm) */
  total: number;
  /** Đã trả trước = tiền cọc */
  deposit: number;
  status: 'deposit' | 'paid' | 'cancelled';
  /** Tổng hoá đơn thực tế khi thanh toán (có thể khác giá báo sau khám) */
  finalAmount?: number;
  /** Khách trả thêm = tổng thực tế − cọc */
  collected?: number;
  paidAt?: number;
  paidBy?: string;
}
export const ORDER_ST: Record<DepositOrder['status'], { label: string; color: string }> = {
  deposit: { label: 'Đã đẩy POS', color: 'cyan' },
  paid: { label: 'Đã thanh toán', color: 'green' },
  cancelled: { label: 'Đã huỷ', color: 'default' },
};

/** Khách của khoản cọc — lưu kèm để Kế toán / POS tra mà không cần mở hồ sơ */
export interface DepositCustomer { id: number; name: string; code: string; phone?: string | null }

export interface Deposit {
  /** id khoản cọc trên server; không có = khách mẫu hoặc cọc cũ chỉ lưu trên máy */
  serverId?: number;
  code: string;
  amount: number;
  purpose: DepPurpose;
  /** Hạn chuyển khoản */
  due: number;
  status: DepSt;
  /** Nội dung chuyển khoản: mã khách + mã báo giá */
  note: string;
  cust?: DepositCustomer;
  /** Telesales tạo yêu cầu */
  by?: string;
  createdAt?: number;
  receiptAt?: number;
  /** Kế toán báo không khớp sao kê → về Chờ chuyển khoản */
  rejectNote?: string;
  receivedAt?: number;
  receivedBy?: string;
  /** Mã giao dịch ngân hàng trên sao kê */
  bankRef?: string;
  /** Đơn hàng cọc tạo khi đẩy qua POS */
  order?: DepositOrder;
  /** Đã trừ vào đơn */
  used?: { orderCode: string; amount: number; at: number; by: string }[];
  closedAt?: number;
  closedBy?: string;
  closeReason?: string;
}

/** Phần cọc đã trừ vào đơn */
export const depositUsed = (d: Deposit) => (d.used ?? []).reduce((s, x) => s + x.amount, 0);
/** Còn phải thu khi khách đến (theo giá báo) */
export const orderDue = (o: DepositOrder) => Math.max(0, o.total - o.deposit);

export interface Quote {
  id: string;
  /** id báo giá trên server; không có = khách mẫu hoặc báo giá cũ chỉ lưu trên máy */
  serverId?: number;
  code: string;
  at: number;
  by: string;
  dichVu: DichVu;
  items: QuoteSvc[];
  promo?: string;
  /** % giảm trong quyền */
  discount: number;
  reason?: string;
  channel: SendCh;
  /** Ngày giờ gửi khách (tương lai = hẹn gửi) */
  sendAt: number;
  /** Hạn giữ ưu đãi */
  validUntil: number;
  status: QuoteSt;
  deposit?: Deposit;
  cancelReason?: string;
  /** Mã báo giá mới thay cho bản này */
  replacedBy?: string;
  /** id bản cũ mà bản này thay thế — bản cũ thành "Đã thay thế" khi bản này được gửi */
  replaces?: string;
  /** Bản cũ trên server: sửa nháp phải gửi lại, không thì mất liên kết thay thế */
  replacesId?: number;
  /** Bản chỉ có trên máy được thay bằng báo giá trên server này: thành "Đã thay thế" khi bản đó được gửi */
  nextServerId?: number;
}

/** Đánh dấu đã gửi; bản cũ nó thay (nếu có) chuyển "Đã thay thế" */
export const markSent = (quotes: Quote[], id: string, at: number): Quote[] => {
  const q = quotes.find((x) => x.id === id);
  if (!q) return quotes;
  return quotes.map((x) => {
    if (x.id === id) return { ...x, status: 'sent', sendAt: at };
    if (q.replaces && x.id === q.replaces && x.status !== 'cancelled') return { ...x, status: 'replaced', replacedBy: q.code };
    return x;
  });
};

export const money = (n: number | null | undefined) => (n == null ? 'chưa có giá' : `${n.toLocaleString('vi-VN')} đ`);

/** Tổng giá từ; có dịch vụ chưa có giá thì null */
export const quoteTotal = (items: QuoteSvc[]): number | null =>
  items.some((x) => x.price == null) ? null : items.reduce((s, x) => s + (x.price ?? 0), 0);

/** "Hifu 5 buổi + Peel 2 buổi (tặng) · dùng 12 tháng" / "Mệnh giá 24.000.000 đ · dùng 12 tháng"; withMoney = false cho bác sĩ (không thấy tiền) */
export const cardSummary = (c: QuoteCard, withMoney = true) => `${c.kind === 'value' ? (withMoney ? `Mệnh giá ${money(c.faceValue)}` : 'Thẻ trả trước')
  : c.items.map((x) => `${x.name} ${x.sessions} buổi${x.bonus ? ' (tặng)' : ''}`).join(' + ')} · dùng ${c.validityMonths ? `${c.validityMonths} tháng` : 'không thời hạn'}`;

export interface QuoteCheck { total: number | null; after: number | null; cap: number; error?: string; needApprove: boolean }
/** % giảm chỉ áp lên dịch vụ lẻ; thẻ liệu trình giữ giá gói */
export const checkQuote = (items: QuoteSvc[], discount: number, reason?: string): QuoteCheck => {
  const total = quoteTotal(items);
  const svcs = items.filter((x) => !x.card);
  const cap = svcs.length > 1 ? TRAN_COMBO : TRAN_GIAM;
  const open = svcs.reduce((s, x) => s + (x.price ?? 0), 0);
  const after = total == null ? null : total - Math.round((open * discount) / 100);
  let error: string | undefined;
  if (!items.length) error = 'Chọn ít nhất 1 dịch vụ.';
  else if (total == null) error = 'Có dịch vụ chưa có giá trong Công cụ báo giá — chỉ mời khám, chưa báo giá được.';
  else if (discount > 0 && !svcs.length) error = 'Thẻ liệu trình bán theo giá gói — không áp giảm %.';
  else if (discount > cap) error = `Giảm ${discount}% vượt trần ${cap}% ${svcs.length > 1 ? 'mỗi combo' : 'mỗi dịch vụ'} — không xin duyệt được.`;
  else if (discount > 0 && !reason?.trim()) error = 'Bắt buộc ghi lý do giảm.';
  return { total, after, cap, error, needApprove: !error && discount > NGUONG_GIAM };
};

/** Mã báo giá BG-MMDD-NN, đánh số theo ngày trong hồ sơ khách */
export const nextQuoteCode = (quotes: Quote[], now: number) => {
  const d = dayjs(now).format('MMDD');
  const n = quotes.filter((q) => q.code.startsWith(`BG-${d}-`)).length + 1;
  return `BG-${d}-${String(n).padStart(2, '0')}`;
};
export const depositNote = (custCode: string, quoteCode: string) => `${custCode.replace(/-/g, '')} ${quoteCode.replace(/-/g, '')}`;

/** Báo giá còn giữ ưu đãi: đã gửi / khách phản hồi và chưa quá hạn */
export const isLive = (q: Quote, now: number) => (q.status === 'sent' || q.status === 'replied') && q.validUntil >= now;
/** Số ngày lịch còn lại của ưu đãi: 0 = hết hạn hôm nay, âm = đã hết hạn */
export const daysLeft = (q: Quote, now: number) => dayjs(q.validUntil).startOf('day').diff(dayjs(now).startOf('day'), 'day');

/** Tin gửi khách — luôn kèm câu "giá tham khảo, báo giá chính thức sau khám" */
export const quoteMessage = (q: Pick<Quote, 'items' | 'promo' | 'discount' | 'validUntil' | 'deposit' | 'code'>, xung: string, name: string) => {
  const X = xung.charAt(0).toUpperCase() + xung.slice(1);
  const c = checkQuote(q.items, q.discount, 'x');
  const lines = [
    `Dạ chào ${xung} ${name}, em gửi ${xung} báo giá tham khảo ${q.code}:`,
    ...q.items.map((x) => (x.card ? `• Thẻ liệu trình ${x.name} (${cardSummary(x.card)}): giá ${money(x.price)}` : `• ${x.name}: giá từ ${money(x.price)}`)),
    ...(q.discount > 0 ? [`Ưu đãi giảm ${q.discount}%${q.items.some((x) => x.card) ? ' dịch vụ lẻ' : ''} → còn từ ${money(c.after)}`] : []),
    ...(q.promo ? [`Kèm ưu đãi: ${q.promo}`] : []),
    `Ưu đãi giữ đến ${dayjs(q.validUntil).format('DD/MM/YYYY')}. Giá tham khảo, báo giá chính thức sau khám; kết quả khác nhau tùy cơ địa.`,
    ...(q.deposit ? [`${X} chuyển cọc ${money(q.deposit.amount)} để ${q.deposit.purpose.toLowerCase()} trước ${dayjs(q.deposit.due).format('DD/MM')}, nội dung: ${q.deposit.note}.`] : []),
    `${X} muốn em giữ lịch khám ngày nào ạ?`,
  ];
  return lines.join('\n');
};
